import { App } from 'vue'
import VueFinalModal from 'vue-final-modal'

/* eslint-disable */
export default {
  install(app: App<Element>) {
    app.use(VueFinalModal as any)
  }
}
